import Network from '@/services/network'

export default function handleApiIntegrationHub() {
    const network = new Network();

    const fetchApiProviders = (query = '') => {
        return network.api('GET', `third-party-hub/provider/integrations${query}`);
    }

    const storeApiProvider = (data, query = '') => {
        return network.api('POST', `third-party-hub/provider/integrations${query}`, data);
    }

    const showApiProvider = (id, query = '') => {
        return network.api('GET', `third-party-hub/provider/integrations/${id}${query}`);
    }

    const updateApiProvider = (id, data, query = '') => {
        return network.api('PUT', `third-party-hub/provider/integrations/${id}${query}`, data);
    }

    const deleteApiProvider = (id, query = '') => {
        return network.api('DELETE', `third-party-hub/provider/integrations/${id}${query}`);
    }

    const regenerateKey = (id, query = '') => {
        return network.api('POST', `third-party-hub/provider/integrations/${id}/regenerate-key${query}`);
    }

    const fetchApiReceivers = (query = '') => {
        const separator = query.includes('?') ? '&' : '?';
        return network.api('GET', `third-party-hub/provider/integrations${query}${separator}type=remote`);
    }

    const storeApiReceiver = (data, query = '') => {
        return network.api('POST', `third-party-hub/provider/integrations${query}`, data);
    }

    const showApiReceiver = (id, query = '') => {
        const separator = query.includes('?') ? '&' : '?';
        return network.api('GET', `third-party-hub/provider/integrations/${id}${query}${separator}type=remote`);
    }

    const updateApiReceiver = (id, data, query = '') => {
        return network.api('PUT', `third-party-hub/provider/integrations/${id}${query}`, data);
    }

    const deleteApiReceiver = (id, query = '') => {
        return network.api('DELETE', `third-party-hub/provider/integrations/${id}${query}`);
    }

    const fetchThirdPartyServices = (query = '') => {
        return network.api('GET', `third-party-hub/provider/services${query}`);
    }

    const pingApiReceiver = (id, query = '') => {
        return network.api('POST', `third-party-hub/provider/integrations/${id}/ping${query}`);
    }

    return {
        fetchApiProviders,
        storeApiProvider,
        showApiProvider,
        updateApiProvider,
        deleteApiProvider,
        regenerateKey,
        fetchApiReceivers,
        storeApiReceiver,
        showApiReceiver,
        updateApiReceiver,
        deleteApiReceiver,
        fetchThirdPartyServices,
        pingApiReceiver
    }
}
